import { Link, NavLink } from "react-router-dom";
import { useAccount } from "wagmi";

function Footer(props) {
  const { isDisconnected } = useAccount();
  return (
    <footer className="footer footer-overlay">
      {props.footerMain === "2" ? (
        <>
          <div className="footer-main pb-3 bg-transparent">
            <div className="container">
              <div className="row">
                <div className="col-xl-3 col-lg-4 col-sm-6">
                  {/* Widget About */}
                  <div className="widget widget_about text-white style--two">
                    <img
                      src="/img/footer-logo-dark.svg"
                      alt=""
                      className="footer-logo"
                    />
                    <p>
                      The anefty first large digital marketplace crypto
                      collectibles & non fungible token buy sell & discover
                      digital .
                    </p>

                    {/* Socials */}
                    <div className="socials d-flex align-items-center">
                      <NavLink to="https://www.twitter.com/">
                        <img
                          src="/img/icons/twitter-round.svg"
                          alt=""
                          className="svg"
                        />
                      </NavLink>
                      <NavLink to="https://www.instagram.com/">
                        <img
                          src="/img/icons/instagram-round.svg"
                          alt=""
                          className="svg"
                        />
                      </NavLink>
                      <NavLink to="https://www.pinterest.com/">
                        <img
                          src="/img/icons/pinterest.svg"
                          alt=""
                          className="svg"
                        />
                      </NavLink>
                      <NavLink to="https://www.whatsapp.com/">
                        <img
                          src="/img/icons/whatsapp.svg"
                          alt=""
                          className="svg"
                        />
                      </NavLink>
                    </div>
                    {/* End Socials */}
                  </div>
                  {/* End Widget About */}
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6">
                  {/* Widget Nav Menu */}
                  <div className="widget widget_nav_menu">
                    <h4 className="widget_title">Marketplace</h4>
                    <ul>
                      <li>
                        <NavLink to="explore.html">All NFTs</NavLink>
                      </li>
                      {/* <li><NavLink to="explore.html">Trading Paint</NavLink></li> */}
                      <li>
                        <NavLink to="explore.html">Art Painting</NavLink>
                      </li>
                      {/* <li><NavLink to="explore.html">Virtual Paints</NavLink></li>
                                <li><NavLink to="explore.html">Collectibles</NavLink></li> */}
                    </ul>
                  </div>
                  {/* End Widget Nav Menu */}
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6">
                  {/* Widget Nav Menu */}
                  <div className="widget widget_nav_menu">
                    <h4 className="widget_title">Resource</h4>
                    <ul>
                      <li>
                        <NavLink to="explore.html">Help Center</NavLink>
                      </li>
                      <li>
                        <NavLink to="explore.html">Platform Status</NavLink>
                      </li>
                      <li>
                        <NavLink to="explore.html">Partners</NavLink>
                      </li>
                      <li>
                        <NavLink to="explore.html">
                          Gas-Free Marketplace
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="explore.html">Suggestions</NavLink>
                      </li>
                    </ul>
                  </div>
                  {/* End Widget Nav Menu */}
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6">
                  {/* Widget Nav Menu */}
                  <div className="widget widget_nav_menu">
                    <h4 className="widget_title">My Account</h4>
                    <ul>
                      <li>
                        <w3m-button />
                      </li>
                      <li>
                        <Link to="/exlpore/profile">Profile</Link>
                      </li>
                      {/* <li><NavLink to="author.html">Author</NavLink></li> */}
                      <li>
                        <Link to="/pages/collection">My Collections</Link>
                      </li>
                      {/* <li><NavLink to="author.html">Settings</NavLink></li> */}
                      {/* <li><NavLink to="activity.html">Activity</NavLink></li> */}
                    </ul>
                  </div>
                  {/* End Widget Nav Menu */}
                </div>
                <div className="col-xl-3 col-lg-4 col-sm-8">
                  {/* Widget Newsletter */}
                  <div className="widget widget_newsletter text-white">
                    <h4 className="widget_title">Stay With Us</h4>
                    <p>
                      Join our mailing list to stay the loop with our newestz
                      feature releases.
                    </p>

                    <form
                      action="https://themelooks.us13.list-manage.com/subscribe/post?u=79f0b132ec25ee223bb41835f&id=f4e0e93d1d"
                      className="newslatter-form style--two sm"
                    >
                      <div className="theme-input-group">
                        <input
                          className="form-control"
                          type="email"
                          placeholder="Email here…"
                        />
                        <button type="submit" className="submit-btn btn">
                          <img
                            src="/img/icons/mail.svg"
                            alt=""
                            className="svg"
                          />{" "}
                          Subscribe
                        </button>
                      </div>
                    </form>
                  </div>
                  {/* End Widget Newsletter */}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="footer-main">
            <div className="container">
              <div className="row">
                <div className="col-xl-2 col-sm-6">
                  {/* Widget Nav Menu  */}
                  <div className="widget widget_nav_menu">
                    <h4 className="widget_title">My Account</h4>
                    <ul>
                      {isDisconnected ? (
                        <li>
                          <w3m-button />
                        </li>
                      ) : (
                        <>
                          <li>
                            <Link to="/explore/create/upload">Mint NFT</Link>
                          </li>
                          {/* <li><NavLink to="author.html">Author</NavLink></li> */}
                          <li>
                            <Link to="/explore/wallet">My Wallet</Link>
                          </li>
                          {/* <li><NavLink to="author.html">Settings</NavLink></li> */}
                          {/* <li><NavLink to="activity.html">Activity</NavLink></li> */}
                        </>
                      )}
                    </ul>
                  </div>
                  {/* End Widget Nav Menu  */}
                </div>
                <div className="col-xl-3 col-sm-6">
                  {/* Widget Nav Menu  */}
                  <div className="widget widget_nav_menu">
                    <h4 className="widget_title">Marketplace</h4>
                    <div className="footer-list-wrap">
                      <ul>
                        <li>
                          <NavLink to="/explore/explore">All NFTs</NavLink>
                        </li>
                        {/* <li><NavLink to="explore.html">Trading Paint</NavLink></li> */}
                        {/* <li><NavLink to="explore.html">Art Painting</NavLink></li> */}
                        {/* <li><NavLink to="explore.html">Virtual Paints</NavLink></li> */}
                        {/* <li><NavLink to="explore.html">Collectibles</NavLink></li> */}
                      </ul>
                      {/* <ul>
                        <li>
                          <NavLink to="contact.html">Terms of Service</NavLink>
                        </li>
                        <li>
                          <NavLink to="contact.html">Privacy Policy</NavLink>
                        </li>
                      </ul> */}
                    </div>
                  </div>
                  {/* End Widget Nav Menu  */}
                </div>
                <div className="col-xl-3 col-sm-6">
                  {/* <div className="widget widget_newsletter">
                    <h4 className="widget_title">Newsletter</h4>

                    <form
                      action="https://themelooks.us13.list-manage.com/subscribe/post?u=79f0b132ec25ee223bb41835f&id=f4e0e93d1d"
                      className="newslatter-form"
                    >
                      <div className="theme-input-group">
                        <input
                          className="form-control"
                          type="email"
                          placeholder="Enter Your Email..."
                        />
                        <button type="submit" className="submit-btn btn">
                          <img
                            src="/img/icons/mail.svg"
                            alt=""
                            className="svg"
                          />{" "}
                          Signup Now
                        </button>
                      </div>
                    </form>
                  </div> */}
                </div>
                <div className="col-xl-4 col-sm-6">
                  {/* {/* Widget About  */}
                  <div className="widget text-center text-white widget_about">
                    <img
                      src="/img/footer-logo-light.svg"
                      alt=""
                      className="svg footer-logo"
                    />
                    <p>
                      The anefty first large digital marketplace crypto
                      collectibles & non fungible token buy sell & discover
                      digital .
                    </p>

                    {/* {/* Socials  */}
                    <div className="socials d-flex justify-content-center align-items-center">
                      <NavLink to="https://www.twitter.com/">
                        <img
                          src="/img/icons/twitter-round.svg"
                          alt=""
                          className="svg"
                        />
                      </NavLink>
                      <NavLink to="https://www.instagram.com/">
                        <img
                          src="/img/icons/instagram-round.svg"
                          alt=""
                          className="svg"
                        />
                      </NavLink>
                      <NavLink to="https://www.pinterest.com/">
                        <img
                          src="/img/icons/pinterest.svg"
                          alt=""
                          className="svg"
                        />
                      </NavLink>
                      <NavLink to="https://www.whatsapp.com/">
                        <img
                          src="/img/icons/whatsapp.svg"
                          alt=""
                          className="svg"
                        />
                      </NavLink>
                    </div>
                    {/* {/* End Socials  */}
                  </div>
                  {/* {/* End Widget About  */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {props.footerType === "1" ? (
        <>
          <div className="footer-bottom">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className={props.footerClasses}>
                    ©<span className="currentYear">2023</span>{" "}
                    <NavLink
                      to="https://www.hashtagweb.dev/"
                      className={props?.textWhite === true ? "text-white" : ""}
                    >
                      Hashtag <span style={{ width: "3px" }}></span>
                    </NavLink>
                    Web. All Right Reserved.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="footer-middle sep-top">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="logo-wrap d-flex justify-content-center justify-content-xl-between flex-wrap align-items-center">
                    <img src="/img/media/f_logo1.png" alt="" />
                    <img src="/img/media/f_logo2.png" alt="" />
                    <img src="/img/media/f_logo3.png" alt="" />
                    <img src="/img/media/f_logo4.png" alt="" />
                    <img src="/img/media/f_logo5.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom sep-top">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className={props.footerClasses}>
                    ©<span className="currentYear">2023</span>{" "}
                    <NavLink
                      to="https://www.hashtagweb.dev/"
                      className={props?.textWhite === true ? "text-white" : ""}
                    >
                      Hashtag <span style={{ width: "3px" }}></span>
                    </NavLink>
                    Web.
                  </div>
                </div>
                {/* <div className="col-md-6">
                  <ul className="footer-menu justify-content-center justify-content-md-end">
                    <li>
                      <NavLink to="contact.html">Privacy Policy</NavLink>
                    </li>
                    <li>
                      <NavLink to="contact.html">Terms of Service</NavLink>
                    </li>
                  </ul>
                </div> */}
              </div>
            </div>
          </div>
        </>
      )}
    </footer>
  );
}

export default Footer;
